module.exports = __webpack_public_path__ + "static/3-a6ed8884bb4be9c4e1627a733aa8e7e9.jpg";